import { useState, useRef } from "react";
import Echo from "laravel-echo";
import { getAuthorization, getCookie } from "../helpers";
import appConfig from "../config/appConfig";

const APP_KEY = "369ebf78f3bf55623472";
const token = getAuthorization();
const options = {
  broadcaster: "pusher",
  key: "7890123456",
  wsHost: appConfig.websocket.wsHost,
  wssPort: appConfig.websocket.wssPort,
  wsPort: appConfig.websocket.wsPort,
  disableStats: true,
  // push server بدون SSL است، بنابراین TLS را غیرفعال می‌کنیم
  forceTLS: false,
  enabledTransports: ["ws", "wss"],
  authEndpoint: appConfig.backend.broadcastingAuth,
  auth: {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  },
};

export const WebSocketSbm = (Chanel, Event) => {
  const [joinData, setJoinData] = useState([]);
  const [typing, setTyping] = useState([]);

  const newEcho = () => {
    return new Echo(options);
  };

  const ChatCallChannel = newEcho.join(Chanel);

  const echoJoin = () => {
    setJoinData([]);
    setTyping([]);

    ChatCallChannel.here((user) => {
      console.log("alll online users", user);
    })
      .joining((user) => {
        console.log(user.id + " Join the Channel");
      })
      .leaving((user) => {
        console.log(user.id + " Leave the Channel");
      })
      .listen(Event, (e) => {
        if (e) {
          setJoinData(e);
        }
      })
      .listenForWhisper("typing", (e) => {
        setTyping(e.typing);
      });
  };

  const sbm_whisper = () => {
    ChatCallChannel.whisper("typing", {
      typing: false,
      name: "",
    });
  };

  return {
    typing,
    joinData,
    ChatCallChannel,
    echoJoin,
    sbm_whisper,
  };
};
